// assets
import { DashboardOutlined, RightSquareOutlined } from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  RightSquareOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Dashboard',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/',
      icon: icons.DashboardOutlined,
      breadcrumbs: false,
      exact: true
    },
    {
      id: 'customers',
      title: 'My Customers',
      type: 'item',
      url: 'customer',
      icon: icons.RightSquareOutlined,
      breadcrumbs: false,
      target: false
    }
  ]
};

export default dashboard;
